import { guidEmpty } from "utils/guid-empty";

export class VotacoesModel {
    constructor(
        public id: string = guidEmpty(),
        public clickup_id: string = '',
        public sistema: string = '',
        public titulo: string = '',
        public descricao: string = '',
        public link: string = '',
        public data_ultima_votacao: Date | undefined = undefined,
        public votos: number = 0,
        public data_cadastro: Date | undefined = undefined,
        public data_aprovacao: Date | undefined = undefined,
        public data_cancelamento: Date | undefined = undefined,
        public votado: boolean = false,
        public porcentagem: number = 0,
    ) { }
}